import React from 'react'
import ReactDOM from 'react-dom'
import { AllRoutes } from './Routes'
import './index.css';

ReactDOM.render(
  <React.StrictMode>
      <AllRoutes />
  </React.StrictMode>,
  document.getElementById('root')
);
